// src/pages/admin/AdminLogin.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Toast from '../../components/common/Toast';

const AdminLogin = () => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!usuario.trim() || !senha.trim()) {
      setToast({ msg: 'Preencha usuário e senha.', type: 'warning' });
      return;
    }
    setLoading(true);
    try {
      const ok = await login(usuario, senha);
      if (ok) {
        navigate('/admin/dashboard');
      } else {
        setToast({ msg: 'Usuário ou senha incorretos.', type: 'error' });
      }
    } catch {
      setToast({ msg: 'Erro ao conectar. Verifique a URL do Google Apps Script.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--navy-dark)',
      padding: 'var(--space-xl)',
    }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      <div style={{
        background: 'var(--white)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--space-2xl)',
        width: '100%',
        maxWidth: '400px',
        boxShadow: 'var(--shadow-lg)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: 56, height: 56,
            background: 'var(--navy)',
            color:  'white',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '2rem', margin: '0 auto 1rem',
          }}>✝</div>
          <h2 style={{ marginBottom: '0.25rem' }}>Área Administrativa</h2>
          <p style={{ fontSize: '0.875rem', color: 'var(--gray-400)' }}>Paróquia Nossa Senhora da Conceição</p>
        </div>

        <form onSubmit={handleSubmit} noValidate> 
          <div className="form-group">
            <label className="form-label">Usuário</label>
            <input
              type="text"
              value={usuario}
              onChange={e => setUsuario(e.target.value)}
              className="form-input"
              autoComplete="username"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Senha</label>
            <input
              type="password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              className="form-input"
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }}
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar →'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.8rem', color: 'var(--gray-400)' }}>
          <a href="/" style={{ color: 'var(--gray-400)' }}>← Voltar ao site</a>
        </p>
      </div>
    </main>
  );
};

export default AdminLogin;
